import { render, staticRenderFns } from "./shop_foot.vue?vue&type=template&id=36506380&scoped=true&"
import script from "./shop_foot.vue?vue&type=script&lang=js&"
export * from "./shop_foot.vue?vue&type=script&lang=js&"
import style0 from "./shop_foot.vue?vue&type=style&index=0&id=36506380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36506380",
  null
  
)

export default component.exports